const WORDS = ["Bespoke Joinery", "Natural Stone", "Timber Veneers", "Solid Brass", "Integrated Appliances", "Finished by Hand"];

const Row = () => (
  <div className="flex shrink-0 items-center gap-16 pr-16">
    {WORDS.map((w) => (
      <span key={w} className="flex items-center gap-16">
        <span className="font-display italic text-5xl sm:text-7xl text-[#F5F3EF]/85 whitespace-nowrap">{w}</span>
        <span className="w-3 h-3 rotate-45 border border-[#D4AF37]" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section className="relative py-14 border-y border-[#D4AF37]/15 overflow-hidden" data-testid="editorial-marquee">
    <div className="flex w-max animate-marquee">
      <Row /><Row />
    </div>
  </section>
);
